import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';
import { getNextState } from './patchApplicationHandlers';

export const acceptInsuranceHandler = [
    http.patch('*/api/cl_loanapp_proxy_service/v1/:countryCode/insurance/:arn', async () => {
        const session = MockServiceWorker.getMockedSession();
        session.state = getNextState('PPI_MAIN_APPLICANT');
        MockServiceWorker.setMockedSession(session);

        return HttpResponse.json({});
    }),
];
